export const LanguageOptionList=[
  { "value": "en", "label": "English" },
  { "value": "es", "label": "Spanish" },
  { "value": "fr", "label": "French" },
  { "value": "de", "label": "German" },
  { "value": "it", "label": "Italian" },
  { "value": "pt", "label": "Portuguese" },
  { "value": "ru", "label": "Russian" },
  { "value": "uk", "label": "Ukrainian" },
  { "value": "nl", "label": "Dutch" },
  { "value": "sv", "label": "Swedish" },
  { "value": "no", "label": "Norwegian" },
  { "value": "da", "label": "Danish" },
  { "value": "fi", "label": "Finnish" },
  { "value": "pl", "label": "Polish" },
  { "value": "cs", "label": "Czech" },
  { "value": "hu", "label": "Hungarian" },
  { "value": "el", "label": "Greek" },
  { "value": "tr", "label": "Turkish" },
  { "value": "ar", "label": "Arabic" },
  { "value": "he", "label": "Hebrew" },
  { "value": "fa", "label": "Persian (Farsi)" },
  { "value": "hi", "label": "Hindi" },
  { "value": "bn", "label": "Bengali" },
  { "value": "pa", "label": "Punjabi" },
  { "value": "gu", "label": "Gujarati" },
  { "value": "mr", "label": "Marathi" },
  { "value": "ta", "label": "Tamil" },
  { "value": "te", "label": "Telugu" },
  { "value": "kn", "label": "Kannada" },
  { "value": "ml", "label": "Malayalam" },
  { "value": "or", "label": "Odia" },
  { "value": "as", "label": "Assamese" },
  { "value": "ur", "label": "Urdu" },
  { "value": "zh", "label": "Chinese (Mandarin)" },
  { "value": "zh-HK", "label": "Chinese (Cantonese)" },
  { "value": "ja", "label": "Japanese" },
  { "value": "ko", "label": "Korean" },
  { "value": "th", "label": "Thai" },
  { "value": "vi", "label": "Vietnamese" },
  { "value": "id", "label": "Indonesian" },
  { "value": "ms", "label": "Malay" },
  { "value": "tl", "label": "Filipino (Tagalog)" },
  { "value": "sw", "label": "Swahili" },
  { "value": "am", "label": "Amharic" },
  { "value": "af", "label": "Afrikaans" }
]